import Component from './PageSettings.vue';

export default {
  install(Vue) {
    Vue.component('BkfPageSettings', Component);
  },
};
